import dynamic from 'next/dynamic';
import { AssociateLoginProps } from './AssociateLogin.types';

export const AssociateLogin = dynamic<{ model: AssociateLoginProps }>(() =>
  import('./AssociateLogin').then(mod => mod.AssociateLogin)
);
